import { containsMalicious } from "../../../helpers/textRestriction";
import messages from "../../../locale/messages";

const validate = values => {

  const errors = {}

  if (!values.message) {
    errors.message = messages.required;
  } else if (values.message && values.message.toString().trim() == '') {
    errors.message = messages.required;
  }else if (containsMalicious(values.message)) {
    errors.message = messages.invalidInput;;
  }

  return errors;
}

export default validate;